import axios from "axios";

export const baseApiLogs = axios.create({
  baseURL: process.env.VUE_APP_LOG_API,
  headers: {
    "Content-type": "application/json",
  },
});
